/**
 * Activities the work log never shows.
 *
 * Two kinds are superseded by their own completion row, and two are
 * bookkeeping the thread never asked for: what the context window is at, and
 * what a title or commit message cost. The last of those reaches the person on
 * /usage as a Text generation row instead, which is where a Usage row belongs.
 *
 * @module workLogHiddenActivities
 */
import type { OrchestrationThreadActivity } from "@cmmd-forge/contracts";

/** The activity carrying what one text generation spent, recorded on FOR-36421. */
const TEXT_GENERATION_USAGE_ACTIVITY_KIND = "text-generation.usage";

const hiddenKinds: ReadonlySet<string> = new Set([
  // Superseded by "tool.completed" and "task.completed".
  "tool.started",
  "task.started",
  "context-window.updated",
  TEXT_GENERATION_USAGE_ACTIVITY_KIND,
  // The launch card presents these step updates together.
  "worktree.stage",
  "launch.agent-starting",
  // Backend replication bookkeeping (CMMD-Center/forge#3562 piece A):
  // redundant with the assistant message, error summary, or interrupt the
  // person already sees for the same turn.
  "turn.terminal-status",
]);

export function isTextGenerationUsageActivity(activity: OrchestrationThreadActivity): boolean {
  return activity.kind === TEXT_GENERATION_USAGE_ACTIVITY_KIND;
}

/** Whether the work log leaves this activity out whatever else is on the thread. */
export function isHiddenWorkLogActivity(
  activity: Pick<OrchestrationThreadActivity, "kind" | "summary">,
): boolean {
  return hiddenKinds.has(activity.kind) || activity.summary === "Checkpoint captured";
}
